export const DECA_VALIDACAO_POST = "deca.VALIDACAO_POST";
export const DECA_VALIDACAO_SET = "deca.VALIDACAO_SET";
export const MODAL_CLOSE = "MODAL_CLOSE";
